import dayjs, { Dayjs } from "dayjs";

export const getDaysDiffNewAccount = (firstDate: Dayjs) => {
  let today = dayjs();
  return 14 - today.diff(firstDate, "days");
};

export const validateEmail = (email: string) => {
  return !!email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};

export const validateEmailsString = (emails: string) => {
  if (emails.includes(",")) {
    const emailArray = emails.split(",");
    return emailArray.every((email) => validateEmail(email));
  } else {
    return validateEmail(emails);
  }
};

export const filterOption = (
  input: string,
  option?: { label: string; value: string },
) =>
  ((option && option.label) || "").toLowerCase().includes(input.toLowerCase());

export const filterOptionGroup = (input: string, option: any) => {
  // Support OptGroup: option.children is the label text
  // option.label is undefined for Option, defined for OptGroup
  if (option && "options" in option) {
    // This is an OptGroup, skip filtering here
    return false;
  }
  // For Option, match input with children (label)
  if (option && option.children) {
    return option.children
      .toString()
      .toLowerCase()
      .includes(input.toLowerCase());
  }
  return false;
};

const colors = [
  "#003f5c", // Deep Blue
  "#2f4b7c", // Dark Indigo
  "#665191", // Muted Purple
  "#a05195", // Plum
  "#d45087", // Dark Pink
  "#f95d6a", // Coral Red
  "#ff7c43", // Deep Orange
  "#ffa600", // Golden Yellow
  "#4e79a7", // Steel Blue
  "#76b7b2", // Teal
  "#59a14f", // Deep Green
  "#edc949", // Goldenrod
  "#af7aa1", // Muted Lavender
  "#ff9da7", // Soft Pink
  "#b07aa1", // Warm Violet
  "#ff6361", // Strong Red
  "#bc5090", // Bold Purple
  "#003f88", // Corporate Blue
  "#546e7a", // Cool Gray
  "#37474f", // Dark Charcoal
];

export const getReadableRandomColor = (): string => {
  const randomIndex = Math.floor(Math.random() * colors.length);
  return colors[randomIndex];
};
